<template>
    <div
        class="loading-container"
        :class="[
            color && `color_${color}`,
            size && `size_${size}`,
            noPadding && 'noPadding',
        ]">
        <component :is="type" :size="size" />
        <Element v-if="label" :size="'m'" font="font-body-m" class="loading-label">
            {{ label }}
        </Element>
    </div>
</template>

<script lang="ts">
    import { defineComponent, PropType } from 'vue';
    import { Type, Color, Size } from './Loading.interfaces';
    import Element from '@ui/components/Element/Element.vue';
    import Dots from './Dots/Dots.vue';
    import Spinner from './Spinner/Spinner.vue';

    export default defineComponent({
        name: 'Loading',
        components: { Element, Spinner, Dots },
        props: {
            type: {
                type: String as PropType<Type>,
                default: 'spinner',
            },
            color: {
                type: String as PropType<Color>,
                default: 'black',
            },
            size: {
                type: String as PropType<Size>,
                default: 'm',
            },
            label: String,
            noPadding: Boolean,
        },
    });
</script>

<style lang="scss">
    @forward './Loading.scss';
</style>
